export const ProductBottleIcon = ({ className }) => {
  return (
    <svg
      width="26"
      height="34"
      viewBox="0 0 26 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className ? className : ""}
    >
      <path
        d="M14.4727 12.0176C18.0283 12.0178 20.9111 14.9003 20.9111 18.4561V31.1221C20.911 32.3 19.9553 33.2549 18.7773 33.2549H10.167C8.98904 33.2549 8.03435 32.3 8.03418 31.1221V18.4561C8.03418 14.9002 10.9168 12.0176 14.4727 12.0176Z"
        stroke="black"
        strokeWidth="0.8"
      />
      <rect
        x="11.4723"
        y="8.54844"
        width="5.99844"
        height="3.14103"
        rx="1.57052"
        stroke="black"
        strokeWidth="0.8"
      />
      <rect
        x="12.3521"
        y="6.14219"
        width="4.31883"
        height="2.09545"
        rx="1.04773"
        stroke="black"
        strokeWidth="0.8"
      />
      <path
        d="M11.5508 5.98438L17.3894 5.98437"
        stroke="black"
        strokeWidth="0.8"
        strokeLinecap="round"
      />
      <path
        d="M12.6006 0.901367C13.4866 0.901367 14.21 1.62496 14.21 2.52344C14.2098 3.42178 13.4865 4.14453 12.6006 4.14453C11.7148 4.14435 10.9914 3.42167 10.9912 2.52344C10.9912 1.62507 11.7147 0.901545 12.6006 0.901367Z"
        stroke="#565656"
        strokeWidth="1.1"
      />
      <path
        d="M4.08203 11.5332C5.50862 11.5332 6.6709 12.6972 6.6709 14.1406C6.67067 15.5839 5.50848 16.748 4.08203 16.748C2.65558 16.748 1.49339 15.5839 1.49316 14.1406C1.49316 12.6972 2.65544 11.5332 4.08203 11.5332Z"
        stroke="#565656"
        strokeWidth="1.3"
      />
      <path
        d="M21.6387 17.8564C23.3312 17.8566 24.708 19.2371 24.708 20.9453C24.7079 22.6534 23.3312 24.034 21.6387 24.0342C19.946 24.0342 18.5694 22.6535 18.5693 20.9453C18.5693 19.237 19.946 17.8564 21.6387 17.8564Z"
        stroke="#565656"
        strokeWidth="0.9"
      />
    </svg>
  );
};
